// Polyfill for Node.js global variable in browser
// define global if not present
if (typeof window !== "undefined" && typeof window.global === "undefined") {
  // @ts-ignore
  window.global = window;
}

import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { QueryClientConfig } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import "./i18n";

Sentry.init({
  dsn: "https://5d047733a70028cc9c095a800eb0700f@o4510347572936704.ingest.us.sentry.io/4510351149629440",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const queryConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
};

const queryClient = new QueryClient(queryConfig);

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
